const classHomeWorkDetails = {
  path: 'classHomeWorkDetails/:pxStudentTopicId',
  component: resolve => require(['../../../../components/pages/student_user/classHomeWorkDetails'], resolve),
  props: true
}
export default classHomeWorkDetails



// WEBPACK FOOTER //
// ./src/router/pages/student_user/classHomeWorkDetails/index.js